export const en = {
    "aired-deploy": "The dialog is being updated. It will take no more than 30 minutes.",
    "aired-in-dev": "Your dialogue has been published. In order to publish a new version, you need to make changes to the settings and send the dialog for moderation.",
    "aired-in-review": "You have submitted a request to moderate the dialog. After successfully passing the moderation, the new version of the dialog can be republished.",
    "aired-review-approved": "The moderator approved your dialog. You can now publish the new version.",
    "appearance": "Appearance",
    "checkbox-directly": "Directly",
    "checkbox-zora": "Through Zora",
    "comment": "Comment",
    "copy": "Copy",
    "danger-zone": "Danger zone",
    "delete-dialog": "Dialog removal",
    "delete-dialog-confirmation": "Are you sure you want to delete the dialog? This action is irreversible.",
    "developer-type": "Developer type",
    "dialog-banned": "Dialog banned.",
    "dialog-id": "Dialog Id",
    "events-history": "Events log",
    "external": "External",
    "headline": "General info",
    "hide": "Hide",
    "internal": "Internal",
    "monitoring-group": "Monitoring group",
    "no": "No",
    "no-monitoring": "Don't monitor",
    "open": "Open",
    "operator-cab": "Operator space",
    "operator-cab-desc": "Here you can reply to customers who have written to you in the chat",
    "publication-canceled-by-user": "Publication cancelled by user",
    "recommended-skill": "Recommended skill",
    "show": "Show",
    "skill-delete-desc": "You can delete the dialog completely. After that, your users will no longer be able to access it.",
    "skill-stop-desc": "Users will lose the access to the dialog. The action is reversible. Frequent stopping and restarting of the dialog can lead to ban.",
    "status-deploy": "The dialog is being published. It will take no more than 30 minutes.",
    "status-in-dev": "You have created a draft. For the dialog to be published, you need to fill in all the settings fields, test it and send it for moderation.",
    "status-in-review": "You have submitted a request to moderate the dialog. After successfully passing the moderation, the dialog can be published.",
    "status-review-approved": "The moderator approved your dialog. Now you can publish it.",
    "stop": "Stop",
    "stop-dialog": "Dialog stop",
    "stop-dialog-confirmation": "The dialog will be inaccessible to users, but it will remain in the system.",
    "title-access-web-hook": "Accessing the Web hook",
    "title-experimental": "Experimental flags",
    "title-open-new-tab": "Open in a new tab",
    "title-safe-kids": "Safe for children",
    "to-delete-dialog": "Delete dialog",
    "to-stop-dialog": "Stop dialog",
    "trusted-skill": "Trusted skill (SH)",
    "yandex": "Yandex",
    "yes": "Yes",
    "unknown-error": "Unknown error. Try submitting the skill for publication again.",
} as const;
export const ru = {
    "aired-deploy": "Идет обновление диалога. Это займёт не более 30 минут.",
    "aired-in-dev": "Ваш диалог опубликован. Для того, чтобы опубликовать новую версию, вам нужно внести изменения в настройки и отправить диалог на модерацию.",
    "aired-in-review": "Вы отправили запрос на модерацию диалога. После успешного прохождения модерации новую версию диалога можно будет переопубликовать.",
    "aired-review-approved": "Модератор одобрил ваш диалог. Теперь вы можете опубликовать новую версию.",
    "appearance": "Внешний вид",
    "checkbox-directly": "Напрямую",
    "checkbox-zora": "Через Zora",
    "comment": "Комментарий",
    "copy": "Скопировать",
    "danger-zone": "Опасные действия",
    "delete-dialog": "Удаление диалога",
    "delete-dialog-confirmation": "Вы уверены, что хотите удалить диалог? Это действие необратимо.",
    "developer-type": "Тип разработчика",
    "dialog-banned": "Диалог забанен.",
    "dialog-id": "Идентификатор диалога",
    "events-history": "История событий",
    "external": "Внешний",
    "headline": "Общие сведения",
    "hide": "Скрывать",
    "internal": "Внутренний",
    "monitoring-group": "Группа мониторинга",
    "no": "Нет",
    "no-monitoring": "Не мониторить",
    "open": "Открыть",
    "operator-cab": "Кабинет оператора",
    "operator-cab-desc": "Здесь вы можете отвечать клиентам, которые написали вам в чате",
    "publication-canceled-by-user": "Модерация отменена пользователем",
    "recommended-skill": "Рекомендованный скилл",
    "show": "Показывать",
    "skill-delete-desc": "Вы можете полностью удалить диалог. После этого ваши пользователи больше не смогут обращаться к нему.",
    "skill-stop-desc": "Пользователи потеряют возможность обращаться к диалогу. Действие обратимо. Частая остановка и перезапуск диалога приведет к его блокировке.",
    "status-deploy": "Идет публикация диалога. Это займёт не более 30 минут.",
    "status-in-dev": "Вы создали черновик. Чтобы диалог был опубликован, нужно заполнить все поля настроек, протестировать его и отправить на модерацию.",
    "status-in-review": "Вы отправили запрос на модерацию диалога. После успешного прохождения модерации диалог можно будет опубликовать.",
    "status-review-approved": "Модератор одобрил ваш диалог. Теперь вы можете опубликовать его.",
    "stop": "Остановить",
    "stop-dialog": "Остановка диалога",
    "stop-dialog-confirmation": "Диалог будет недоступен для пользователей, но останется в системе.",
    "title-access-web-hook": "Обращение к веб-хуку",
    "title-experimental": "Экспериментальные флаги",
    "title-open-new-tab": "Открывать в новой вкладке",
    "title-safe-kids": "Безопасен для детей",
    "to-delete-dialog": "Удалить диалог",
    "to-stop-dialog": "Остановить диалог",
    "trusted-skill": "Доверенный скилл (УД)",
    "yandex": "Яндекс",
    "yes": "Да",
    "unknown-error": "Неизвестная ошибка. Попробуйте отправить навык на публикацию ещё раз.",
} as const;